// src/components/opportunity/opportunityDocumentsConstants.ts
//
// Display constants for the Documents tab. Kept in their own module
// (importable by both the category section and the tab container)
// instead of forcing an import from the server-only config.

export const OPPORTUNITY_DOC_ALLOWED_EXTENSIONS = ["PDF", "JPEG", "PNG"];
export const OPPORTUNITY_DOC_HUMAN_MAX = "25 MB";
